import { render, staticRenderFns } from "./OsCountLabel.vue?vue&type=template&id=4ef4d713&scoped=true&"
import script from "./OsCountLabel.vue?vue&type=script&lang=js&"
export * from "./OsCountLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4d713",
  null
  
)

export default component.exports